import React from 'react';
import {PriceInVenueCurrency} from "./ui/PriceInVenueCurrency";
import { toLocalDate } from '../../yoello-lib/modules/utils/TimeConversion';

export const customerColumns = [
    {
        key: "first_name", label: 'customers.columns.name',
        componentTransform: (name: string, key: any,props:any) => {
            return <span key={`${key}-name`}>{`${props.first_name} ${props.last_name}`}</span>
        }
    },
    {
        key: "latest_order", label: 'customers.columns.transactionDate',
        componentTransform: (date: string, key: any) => {
            return <span key={`${key}-date`}>{toLocalDate(date,"D/MM/YYYY")}</span>
        }
    },
    {
        key: "total_orders", label: 'customers.columns.noOfOrders',
        componentTransform: (totalOrders: any, key: any) => {
            return <span key={`${key}-value`}>{totalOrders}</span>
        }
    },
    {
        key: "total_spend", label: 'customers.columns.totalSpent',
        componentTransform: (totalSpent: any, key: any) => {
            return <span key={`${key}-value`}>
                <PriceInVenueCurrency price={totalSpent}/>
            </span>;
        },
    },
];